import React from "react";
import Button from "./Button";
import { applyZoom } from "../utils/zoom";
import { getZoomRatio } from "../utils/customUtil";
import { ReactComponent as IconZoomIn } from '../assets/icons/Zoom in.svg'
import { ReactComponent as IconZoomOut } from '../assets/icons/Zoom outt.svg'

const ZoomSettings = ({ setZoom, zoom, canvas }) => {
    const zoomIn = () => {
        if (zoom > 1.2) return;
        const value = zoom + 0.2;
        setZoom(value);
        applyZoom(canvas, value);
    };

    const zoomOut = () => {
        const value = zoom - 0.2;
        const zoomRatio = getZoomRatio();
        if (value >= zoomRatio) {
            setZoom(value);
            applyZoom(canvas, value);
        } else {
            setZoom(zoomRatio);
            applyZoom(canvas, zoomRatio);
        }
    };

    return (
        <>
            <div className="setting flex flex small-buttons">
                <Button handleClick={zoomIn} title="zoom-in" name="zoom-in">
                    <IconZoomIn />
                </Button>
                <Button handleClick={zoomOut} title="zoom-out" name="zoom-out">
                    <IconZoomOut />
                </Button>
            </div>
        </>
    );
};

export default ZoomSettings;
